// @flow
import * as React from 'react';
import { ButtonBase, Stack, styled, Typography } from '@mui/material';
import { UserAvatar } from '../shared';
import { ClientListTimer } from './client-columns/client-list-timer';
import { AgentCallAgendaTaskOutput } from '@coverright/data-access/types/enrollment';

type Props = {
  client: AgentCallAgendaTaskOutput,
  showTime?: boolean
};
export const RoundRobinLead = ({client, showTime}: Props) => {
  return (
    <ButtonBase onClick={() => window.open(`/${'client'}/${client!.clientId}`, '_blank')}
                key={client!.clientId}
                sx={{
                  padding: '4px 8px',
                  borderRadius: '8px',
                  border: `1px solid ${client?.priorityReason ? '#53acc9' : '#FFF'}`,
                  position: 'relative',
                }}
    >
      {client.priorityReason && <PriorityReasonLabel>{client.priorityReason}</PriorityReasonLabel>}
      <Stack direction={'row'} gap={4} width={1} alignItems={'center'} justifyContent={'space-between'}>
        <UserAvatar size={32}
                    fontSize={13}
                    showEmail
                    key={client!.clientId}
                    email={client!.clientEmail || ''}
                    name={client!.clientName ? `${client!.clientName}${client!.state ? ` (${client!.state})` : ''}` : ''} />
        {showTime && <Typography variant={'body2'} align={'right'}>
          <Typography variant={'caption'} color={'text.secondary'}>Time since creation</Typography><br />
          <ClientListTimer createdAt={client.createdAt} />
        </Typography>}
      </Stack>
    </ButtonBase>
  );
};

const PriorityReasonLabel = styled(Typography)(({theme}) => ({
  position: 'absolute',
  left: 9,
  top: -12,
  background: '#FFF',
  color: '#53acc9',
  fontSize: 12,
  fontWeight: 600,
}))

